export enum EditableField {
  InvestorCurrency = 'investorCurrency',
  FeeTemplateId = 'feeTemplateId',
  CarriedInterestFeeTemplateId = 'carriedInterestFeeTemplateId',
  EqualisationInterestFeeTemplateId = 'equalisationInterestFeeTemplateId',
}
